export {features, interactiveFeatures, userGeolocation, wms, osm, metaData, metaDataWithAttribution, metaDataWithLegend, metaDataWithMiniLegend} from '../src/js/config/map/layers';
